export enum Themes {
  DEFAULT = "DEFAULT",
  DARK = "DARK",
}
